import { render } from "./ImageViewer.vue?vue&type=template&id=01b639f7"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
